module.exports = "//img1.rrcimg.com/_next/static/src/assets/xt_1Txh9.png";